import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { DsrIconsModule } from '@desyre/icons-angular';
import { ChatbotLlmOption, ChatbotMediaOption } from '../../../types/chatbot.model'

@Component({
    selector: 'app-chatbot-chat-input',
    templateUrl: './chatbot-chat-input.component.html',
    styleUrls: ['./chatbot-chat-input.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ChatbotChatInputComponent {
  /**
   * Input properties
   */
  readonly message = input.required<FormControl<string>>();
  readonly canSendMessage = input.required<boolean>();
  readonly limitReached = input<boolean>(false);
  readonly remainingMessages = input<number>(20);
  /**
   * Output events
   */
  readonly enterPressed = output<Event>();
  readonly submitBtnClicked = output();
  protected readonly CHATBOT_CHAR_LIMIT = 200;
  chatbotCharCount = signal<number>(0);

  get messageCounterColor(): string {
    const remaining = this.remainingMessages();
    if(remaining <= 0) return '#e74c3c';
    if(remaining <= 3) return '#e67e22';
    return '#2ecc71';
  }

  onMessageInput() {
    const currentLength = this.message().value.length;
    this.chatbotCharCount.set(currentLength);
  }

  onsubmitBtnClicked() {
    this.chatbotCharCount.set(0);
    this.submitBtnClicked.emit();
    this.message().reset('');
  }
  
  onEnterPressed(event: Event) {
    event.preventDefault();
    if(this.canSendMessage()) {
      this.onsubmitBtnClicked();
    }
  }
}